import "./projects-page.css";
import konkurs_skolarci from "../../assets/2026-27/Gorusica_Stipendije_Skolarci_2026_27_Konkurs.pdf";
import konkurs_studenti from "../../assets/2026-27/Gorusica_Stipendije_Studenti_2026_27_Konkurs.pdf";

export default function ProjectsPage() {
  return (
    <div id="ProjectsPage">
      <div className="projects-page-wrapper">
        <div className="projects-page-left">
          <p className="projects-page-heading">Stipendije</p>

          <div className="projects-download-row">
            <a
              className="download-btn"
              href={konkurs_skolarci}
              download="Gorusica_Stipendije_Skolarci_2026_27_Konkurs.pdf"
            >
              Preuzmi konkurs - Stipendije (Školarci) 2026/27.
            </a>
            <a
              className="download-btn"
              href={konkurs_studenti}
              download="Gorusica_Stipendije_Studenti_2026_27_Konkurs.pdf"
            >
              Preuzmi konkurs - Stipendije (Studenti) 2026/27.
            </a>
          </div>

          <hr className="projects-divider" />

          <div className="projects-page-gallery">
            {/* <a href="#tally-open=NpZDoG&tally-layout=modal">*/}
            <div className="gallery-box gallery-box-first">
              <div className="gallery-box-content-heading">
                <p>Stipendije (Školarci) 2026/27.</p>
                <span>Rok za prijavu: 31.08-11.09.2026.</span>
              </div>
              <div className="gallery-box-content">
                <p>KONKURS JE ZATVOREN</p>
              </div>
            </div>
            {/*</a>*/}
            {/* <a href="#tally-open=9qKXDG&tally-layout=modal">*/}
            <div className="gallery-box gallery-box-second">
              <div className="gallery-box-content-heading">
                <p>Stipendije (Studenti) 2026/27.</p>
                <span>Rok za prijavu: 15.09-01.10.2026.</span>
              </div>
              <div className="gallery-box-content">
                <p>KONKURS JE ZATVOREN</p>
              </div>
            </div>
            {/*</a>*/}
          </div>
        </div>
      </div>
    </div>
  );
}
